/**
 * Main Hero Component
 */
import { imgPath } from '../utils/imgPath.js';

export class MainHero {
    // Variant 제거 - 모든 프리뷰를 중앙 정렬로 통일
    mapClasses = [];
    
    previews = [
        {
            img: imgPath('main-hero/bg-1.jpg?v=260127-1124'),
            title: "노동사건",
            tags: "Labor Cases",
            description: "부당해고·징계·임금·근로시간 분쟁 등 개별 사건의 승패를 넘어,<br>향후 리스크를 최소화하는 사건 대응 전략과 인사 구조 개선을 병행합니다.",
            link: "/business-area/labor-cases",
        },
        {
            img: imgPath('main-hero/bg-2.jpg?v=260127-1124'),
            title: "직장 내 성희롱/괴롭힘",
            tags: "Workplace Harassment",
            description: "사건 조사와 조치에 그치지 않고 조직 문화와 제도 전반을 점검하여<br>분쟁을 예방하는 내부 기준과 시스템을 구축합니다.",
            link: "/business-area/workplace-harassment",
        },
        {
            img: imgPath('main-hero/bg-3.jpg?v=260127-1124'),
            title: "집단적 노사관계",
            tags: "Collective Labor Relations",
            description: "노사 갈등의 원인을 구조적으로 진단하고, 단체교섭·쟁의 대응부터<br>중장기적 노사관계 안정화 전략까지 현장에서 작동하는 노사관리 기준을 구축합니다.",
            link: "/business-area/collective-labor-relations",
        },
        {
            img: imgPath('main-hero/bg-4.jpg?v=260127-1124'),
            title: "산업재해",
            tags: "Industrial Accidents",
            description: "산재 발생 원인 분석부터 행정·법률 대응, 재발 방지 대책까지<br>사후 대응과 예방 체계를 함께 설계하는 컨설팅을 제공합니다.",
            link: "/business-area/industrial-accidents",
        },
        {
            img: imgPath('main-hero/bg-5.jpg?v=260127-1124'),
            title: "기업자문",
            tags: "Corporate Advisory",
            description: "급여·근로시간·인사제도·4대보험·ESG까지 기업 운영 전반에 대해<br>법과 경영을 함께 이해하는 상시 인사·노무 자문을 제공합니다.",
            link: "/business-area/corporate-advisory",
        },
        {
            img: imgPath('main-hero/bg-6.jpg?v=260127-1124'),
            title: "급여/4대보험",
            tags: "Payroll & 4 Major Insurances",
            description: "급여체계 설계, 4대보험 실무 점검, 노동관계법 리스크 진단을 통해<br>분쟁과 행정 리스크를 예방하는 구조를 만듭니다.",
            link: "/business-area/payroll-insurance",
        },
        {
            img: imgPath('main-hero/bg-7.jpg', true),
            title: "중대재해/산업안전",
            tags: "Serious Accidents & Industrial Safety",
            description: "중대재해처벌법, 산업안전보건법을 중심으로 법적 책임과 경영 리스크를 함께 고려한<br>실효성 있는 안전관리체계와 대응 구조를 설계합니다.",
            link: "/business-area/serious-accidents",
        },
        {
            img: imgPath('main-hero/bg-8.jpg', true),
            title: "컨설팅",
            tags: "Consulting",
            description: "인사·노무 리스크를 사전에 진단하고, 법률에 부합하며<br>현장에서 안정적으로 작동하는 인사관리 체계를 설계하는 종합 컨설팅입니다.",
            link: "/consulting/hr-audit",
        },
    ];
    
    constructor() {
        const container = document.querySelector(".no-main-hero__container");
        if (!container) return; // 메인 페이지가 아니면 종료
        const items = document.querySelectorAll(".no-main-hero__item");
        let activePreview = document.querySelector(".no-main-hero__preview--default");

        // 클로저 변수로 저장
        const previews = this.previews;
        const mapClasses = this.mapClasses;

        let isMouseOverItem = false;
        let currentIndex = 0;
        let progressInterval = null;
        let progressTimeline = null;
        const progressDuration = 5500; // 5.5초

        // 통일된 clip-path 애니메이션 패턴 (중앙에서 확장)
        const clipPathPattern = {
            start: "polygon(50% 50%, 50% 50%, 50% 50%, 50% 50%)",
            end: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)"
        };
        
        const defaultTransforms = {
            "content": { y: 30, opacity: 0 },
            title: { y: 0, opacity: 0 },
            description: { y: 0, opacity: 0 },
            "action-btn": { y: 0, opacity: 0 },
        };

        function applyDefaultStyles(previewElement) {
            // 모든 요소를 초기 상태로 설정
            Object.entries(defaultTransforms).forEach(
                ([elementClass, transform]) => {
                    const element = previewElement.querySelector(
                        `.no-main-hero__preview-${elementClass}`
                    );
                    if (element) {
                        gsap.set(element, transform);
                    }
                }
            );
            
            // 이미지도 초기 상태로 설정 (통일된 패턴)
            const img = previewElement.querySelector(".no-main-hero__preview-img");
            if (img) {
                gsap.set(img, {
                    clipPath: clipPathPattern.start
                });
            }
        }

        // 배경 이미지 변경 함수 제거 - 그라디언트 배경 사용
        // function changeBg는 더 이상 필요 없음

        function resetAllProgress() {
            // progress bar 제거로 인해 더 이상 필요 없음
        }

        function startProgress(index) {
            // progress bar 제거로 인해 setTimeout으로 자동 전환 처리
            if (progressTimeline) {
                clearTimeout(progressTimeline);
            }
            
            progressTimeline = setTimeout(() => {
                // 다음 아이템으로 이동
                currentIndex = (currentIndex + 1) % items.length;
                switchPreview(currentIndex);
                startProgress(currentIndex);
            }, progressDuration);
        }

        function switchPreview(index) {
            const newActivePreview = document.querySelector(`.no-main-hero__preview-${index + 1}`);
            if (!newActivePreview) return;

            // 모든 preview의 버튼 비활성화
            const allPreviews = document.querySelectorAll(".no-main-hero__preview");
            allPreviews.forEach((preview) => {
                const btn = preview.querySelector(".no-main-hero__preview-action-btn");
                if (btn) {
                    gsap.set(btn, { pointerEvents: "none" });
                }
            });

            // GSAP Timeline을 사용하여 순차적 애니메이션 처리
            const tl = gsap.timeline();

            // 이전 프리뷰가 있고 새 프리뷰와 다를 때만 fadeOut 애니메이션 실행
            if (activePreview && activePreview !== newActivePreview) {
                const previousActivePreviewImg = activePreview.querySelector(".no-main-hero__preview-img");
                const previousActivePreviewBg = activePreview.querySelector(".no-main-hero__preview-bg");
                const previousActivePreviewContent = activePreview.querySelector(".no-main-hero__preview-content");
                const previousActivePreviewTitle = activePreview.querySelector(".no-main-hero__preview-title");
                const previousActivePreviewDescription = activePreview.querySelector(".no-main-hero__preview-description");
                const previousActivePreviewBtn = activePreview.querySelector(".no-main-hero__preview-action-btn");

                // 1단계: 텍스트 요소들 fadeOut (동시에)
                if (previousActivePreviewContent) {
                    tl.to(previousActivePreviewContent, {
                        y: 30,
                        opacity: 0,
                        duration: 0.5,
                        ease: "power2.in"
                    }, 0);
                }
                
                if (previousActivePreviewTitle) {
                    tl.to(previousActivePreviewTitle, {
                        opacity: 0,
                        duration: 0.5,
                        ease: "power2.in"
                    }, 0);
                }
                
                if (previousActivePreviewDescription) {
                    tl.to(previousActivePreviewDescription, {
                        opacity: 0,
                        duration: 0.5,
                        ease: "power2.in"
                    }, 0);
                }
                
                if (previousActivePreviewBtn) {
                    tl.to(previousActivePreviewBtn, {
                        opacity: 0,
                        duration: 0.5,
                        ease: "power2.in"
                    }, 0);
                }

                // 2단계: clipPath를 중앙으로 복귀 (텍스트 fadeOut과 약간 겹치게)
                if (previousActivePreviewImg) {
                    tl.to(previousActivePreviewImg, {
                        clipPath: clipPathPattern.start,
                        duration: 0.8,
                        ease: "power3.in"
                    }, 0.2);
                }

                // 3단계: 배경 이미지 fadeOut
                if (previousActivePreviewBg) {
                    tl.to(previousActivePreviewBg, {
                        opacity: 0,
                        duration: 0.6,
                        ease: "power2.in"
                    }, 0.3);
                }

                // 4단계: 전체 preview opacity 0 (모든 애니메이션 완료 후)
                tl.to(activePreview, {
                    opacity: 0,
                    duration: 0.2
                }, 0.8);

                // 5단계: 새 프리뷰 준비 및 표시 시작 (이전 애니메이션 완료 후)
                tl.call(() => {
                    // 새 프리뷰를 초기 상태로 설정
                    gsap.set(newActivePreview, { opacity: 1 });
                    
                    // 새 프리뷰의 모든 요소를 초기 상태로 설정
                    const newContent = newActivePreview.querySelector(".no-main-hero__preview-content");
                    const newTitle = newActivePreview.querySelector(".no-main-hero__preview-title");
                    const newDescription = newActivePreview.querySelector(".no-main-hero__preview-description");
                    const newBtn = newActivePreview.querySelector(".no-main-hero__preview-action-btn");
                    const newImg = newActivePreview.querySelector(".no-main-hero__preview-img");
                    const newBg = newActivePreview.querySelector(".no-main-hero__preview-bg");

                    if (newContent) {
                        gsap.set(newContent, { y: 30, opacity: 0 });
                    }
                    if (newTitle) {
                        gsap.set(newTitle, { y: 0, opacity: 0 });
                    }
                    if (newDescription) {
                        gsap.set(newDescription, { y: 0, opacity: 0 });
                    }
                    if (newBtn) {
                        gsap.set(newBtn, { y: 0, opacity: 0 });
                    }
                    if (newImg) {
                        gsap.set(newImg, { clipPath: clipPathPattern.start, scale: 1.05 });
                    }
                    if (newBg) {
                        gsap.set(newBg, { opacity: 0 });
                    }
                }, null, 1.0);

                // 6단계: 새 배경 이미지 표시
                const newActivePreviewBg = newActivePreview.querySelector(".no-main-hero__preview-bg");
                if (newActivePreviewBg) {
                    tl.to(newActivePreviewBg, {
                        opacity: 0.15,
                        duration: 0.6,
                        ease: "power2.out"
                    }, 1.1);
                }

                // 7단계: 새 이미지 clipPath 애니메이션
                const newActivePreviewImg = newActivePreview.querySelector(".no-main-hero__preview-img");
                if (newActivePreviewImg) {
                    tl.to(newActivePreviewImg, {
                        clipPath: clipPathPattern.end,
                        duration: 1.2,
                        ease: "power4.out"
                    }, 1.2);
                    
                    tl.to(newActivePreviewImg, {
                        scale: 1,
                        duration: 1.2,
                        ease: "power2.out"
                    }, 1.2);
                }

                // 8단계: 새 콘텐츠 그룹 애니메이션
                const newContentGroup = newActivePreview.querySelector(".no-main-hero__preview-content");
                if (newContentGroup) {
                    tl.to(newContentGroup, {
                        y: 0,
                        opacity: 1,
                        duration: 0.8,
                        ease: "power3.out"
                    }, 1.4);
                }

                // 9단계: 개별 요소 애니메이션 (stagger 효과)
                const newTitle = newActivePreview.querySelector(".no-main-hero__preview-title");
                if (newTitle) {
                    tl.to(newTitle, {
                        y: 0,
                        opacity: 1,
                        duration: 0.6,
                        ease: "power2.out"
                    }, 1.5);
                }

                const newDescription = newActivePreview.querySelector(".no-main-hero__preview-description");
                if (newDescription) {
                    tl.to(newDescription, {
                        y: 0,
                        opacity: 1,
                        duration: 0.6,
                        ease: "power2.out"
                    }, 1.65);
                }

                const newActivePreviewBtn = newActivePreview.querySelector(".no-main-hero__preview-action-btn");
                if (newActivePreviewBtn) {
                    tl.to(newActivePreviewBtn, {
                        y: 0,
                        opacity: 1,
                        duration: 0.6,
                        ease: "power2.out"
                    }, 1.8);
                    
                    // 버튼 클릭 가능하도록 설정 (애니메이션 완료 후)
                    tl.call(() => {
                        gsap.set(newActivePreviewBtn, {
                            pointerEvents: "auto"
                        });
                    }, null, 2.4);
                }

                // activePreview 업데이트
                activePreview = newActivePreview;
            } else {
                // 첫 번째 로드 시에는 바로 새 프리뷰 표시
                gsap.set(newActivePreview, { opacity: 1 });
                activePreview = newActivePreview;
            }
            
            // nav-item active 상태 업데이트
            items.forEach((item, idx) => {
                if (idx === index) {
                    item.classList.add('is-active');
                } else {
                    item.classList.remove('is-active');
                }
            });
        }

        function resetToDefault() {
            if (activePreview) {
                gsap.to(activePreview, { opacity: 0, duration: 0.1 });
                const defaultPreview = document.querySelector(".no-main-hero__preview--default");
                if (defaultPreview) {
                    gsap.to(defaultPreview, { opacity: 1, duration: 0.1 });
                    activePreview = defaultPreview;

                    const activePreviewImg = activePreview.querySelector(".no-main-hero__preview-img");
                    if (activePreviewImg) {
                        gsap.to(activePreviewImg, {
                            clipPath: clipPathPattern.start,
                            duration: 1,
                            ease: "power3.out",
                        });
                    }
                }
            }
        }

        // 프리뷰 요소 생성 (각 preview에 배경 이미지와 버튼 포함)
        previews.forEach((preview, index) => {
            const previewElement = document.createElement("div");
            previewElement.className = `no-main-hero__preview no-main-hero__preview-${index + 1}`;
            
            // 배경 이미지를 preview-bg로 추가
            previewElement.innerHTML = `
                <div class="no-main-hero__preview-bg">
                    <img src="${preview.img}" alt=""/>
                </div>
                <div class="no-main-hero__preview-img"><img src="${preview.img}" alt=""/></div>
                <div class="no-main-hero__preview-content">
                    <div class="no-main-hero__preview-title"><h1>${preview.title}</h1></div>
                    <div class="no-main-hero__preview-tags"><p>${preview.tags}</p></div>
                    <div class="no-main-hero__preview-description"><p>${preview.description}</p></div>
                    <a href="${preview.link}" class="no-main-hero__preview-action-btn">
                        <span>자세히 보기</span>
                        <i class="fa-light fa-arrow-right"></i>
                    </a>
                </div>
            `;
            container.appendChild(previewElement);
            applyDefaultStyles(previewElement);
            
            // 모든 preview의 opacity를 명확히 설정 (GSAP 사용)
            if (index === 0) {
                gsap.set(previewElement, { opacity: 1 });
            } else {
                gsap.set(previewElement, { opacity: 0 });
            }
            
            // 배경 이미지 초기 상태 설정
            const bgElement = previewElement.querySelector(".no-main-hero__preview-bg");
            if (bgElement) {
                if (index === 0) {
                    gsap.set(bgElement, { opacity: 0.15 });
                } else {
                    gsap.set(bgElement, { opacity: 0 });
                }
            }

            // 버튼 초기 상태 설정 (첫 번째만 클릭 가능)
            const btnElement = previewElement.querySelector(".no-main-hero__preview-action-btn");
            if (btnElement) {
                if (index === 0) {
                    gsap.set(btnElement, { pointerEvents: "auto" });
                } else {
                    gsap.set(btnElement, { pointerEvents: "none" });
                }
            }
        });

        // 이벤트 핸들러 설정
        items.forEach((item, index) => {
            // 클릭 이벤트
            item.addEventListener("click", () => {
                // 자동 전환 중지 및 재시작
                if (progressTimeline) {
                    clearTimeout(progressTimeline);
                }
                currentIndex = index;
                switchPreview(index);
                startProgress(index);
            });

            // 호버 이벤트 (필요시 주석 해제)
            // item.addEventListener("mouseenter", () => {
            //     isMouseOverItem = true;
            //     switchPreview(index);
            // });

            // item.addEventListener("mouseleave", () => {
            //     isMouseOverItem = false;
            //     applyVariantStyles(activePreview, true);
            //     setTimeout(() => {
            //         if (!isMouseOverItem) {
            //             resetToDefault();
            //         }
            //     }, 10);
            // });
        });

        // 현재 시각 업데이트
        function updateLocalTime() {
            const timeElement = document.getElementById('local-time');
            if (!timeElement) return;

            const now = new Date();
            const hours = now.getHours();
            const minutes = now.getMinutes();
            const ampm = hours >= 12 ? 'PM' : 'AM';
            const displayHours = hours % 12 || 12;
            const displayMinutes = minutes.toString().padStart(2, '0');
            
            timeElement.textContent = `${displayHours}:${displayMinutes}${ampm}`;
        }

        // 초기 시간 설정 및 1분마다 업데이트
        updateLocalTime();
        setInterval(updateLocalTime, 60000); // 1분마다 업데이트

        // 모든 preview의 opacity를 명확히 초기화 (겹침 방지)
        const allPreviews = document.querySelectorAll(".no-main-hero__preview");
        allPreviews.forEach((preview, index) => {
            if (index === 0) {
                gsap.set(preview, { opacity: 1 });
            } else {
                gsap.set(preview, { opacity: 0 });
            }
        });

        // 첫 번째 preview를 activePreview로 명확히 설정
        const firstPreview = document.querySelector(".no-main-hero__preview-1");
        if (firstPreview) {
            activePreview = firstPreview;
            gsap.set(firstPreview, { opacity: 1 });
            
            const firstContent = firstPreview.querySelector(".no-main-hero__preview-content");
            const firstTitle = firstPreview.querySelector(".no-main-hero__preview-title");
            const firstDescription = firstPreview.querySelector(".no-main-hero__preview-description");
            const firstImg = firstPreview.querySelector(".no-main-hero__preview-img");
            const firstBtn = firstPreview.querySelector(".no-main-hero__preview-action-btn");
            const firstBg = firstPreview.querySelector(".no-main-hero__preview-bg");
            
            // 초기 상태 설정 (이미지는 start 상태로 유지하여 애니메이션 적용)
            if (firstContent) {
                gsap.set(firstContent, { y: 0, opacity: 1 });
            }
            if (firstTitle) {
                gsap.set(firstTitle, { y: 0, opacity: 1 });
            }
            if (firstDescription) {
                gsap.set(firstDescription, { y: 0, opacity: 1 });
            }
            // 이미지는 start 상태로 유지 (애니메이션으로 전환)
            if (firstImg) {
                gsap.set(firstImg, { clipPath: clipPathPattern.start });
            }
            if (firstBtn) {
                gsap.set(firstBtn, { y: 0, opacity: 1 });
            }
            if (firstBg) {
                gsap.set(firstBg, { opacity: 0.15 });
            }
        }

        // 첫 번째 아이템 active 상태 설정 (다른 아이템의 active 제거)
        items.forEach((item, idx) => {
            if (idx === 0) {
                item.classList.add('is-active');
            } else {
                item.classList.remove('is-active');
            }
        });

        // 첫 번째 preview의 이미지 애니메이션 (최초 로드 시)
        if (firstPreview) {
            const firstImg = firstPreview.querySelector(".no-main-hero__preview-img");
            if (firstImg) {
                // 약간의 딜레이 후 애니메이션 시작
                gsap.to(firstImg, {
                    clipPath: clipPathPattern.end,
                    duration: 1.5,
                    ease: "power4.out",
                    delay: 0.3
                });
                
                // 이미지에 약간의 부드러운 움직임 추가
                gsap.fromTo(firstImg, 
                    { scale: 1.05 },
                    { 
                        scale: 1,
                        duration: 1.5,
                        ease: "power2.out",
                        delay: 0.3
                    }
                );
            }
        }

        // currentIndex를 0으로 명확히 설정하고 autoplay 시작
        currentIndex = 0;
        startProgress(currentIndex);
    }
}
